module.exports = "<nav class=\"nav-tabs\">\n  <ul>\n    <li><a ui-sref=\"checkin.settings\" ui-sref-active=\"active\" ui-sref-active-eq class=\"icon-settings\">{{'common.configuration' | translate}}</a></li>\n  </ul>\n</nav>\n\n<div class=\"nav-tabs-contents\">\n  <div class=\"page-content\" ui-view></div>\n</div>\n";


/*****************
 ** WEBPACK FOOTER
 ** ./client/app/components/checkin/checkin.html
 ** module id = 578
 ** module chunks = 0
 **/